<template>
  <div id="login_main">
    <div class="login_box">
      <div class="login_warp register_warp">
        <div class="form" id="loginForm">
          <el-form ref="loginForm" :model="form" :rules="loginRules" class="login-form" auto-complete="on"
            label-position="left">
            <div class="title-container">
              <h3 class="title">用户注册</h3>
            </div>
            <el-form-item prop="phone">
              <div class="flex align_center input_row">
                <img class="icon_input" src="../../assets/img/icon-personal.png" alt="" srcset="">
                <el-input class="el-input" ref="username" v-model="form.phone" placeholder="请输入帐号" name="username"
                  type="text" tabindex="1" auto-complete="on" />
              </div>
            </el-form-item>
            <el-form-item prop="code">
              <el-row :gutter="10">
                <el-col :span="16">
                  <div class="flex align_center input_row">
                    <img class="icon_input" src="../../assets/img/yanzhengma.png" alt="" srcset="">
                    <el-input :key="passwordType" ref="password" v-model="form.code" :type="passwordType"
                      placeholder="请输入验证码" name="password" tabindex="2" auto-complete="on"
                      @keyup.enter.native="handleLogin" />
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="flex align_center">
                    <div id="v_container"></div>
                  </div>
                </el-col>
              </el-row>
            </el-form-item>
            <!-- <el-form-item prop="verifyCode">
              <el-row :gutter="10">
                <el-col :span="16"><el-input v-model="form.code" placeholder="验证码"
                    @keyup.enter.native="submitForm"></el-input></el-col>
                <el-col :span="8">
                  <div id="v_container"></div>
                </el-col>
              </el-row>
            </el-form-item> -->
            <el-form-item prop="password">
              <div class="flex align_center input_row">
                <img class="icon_input" src="../../assets/img/mima.png" alt="" srcset="">
                <el-input :key="passwordType" ref="password" v-model="form.password" :type="passwordType"
                  placeholder="请输入密码" name="password" tabindex="2" auto-complete="on" @keyup.enter.native="handleLogin" />
              </div>
            </el-form-item>
            <el-form-item prop="classId">
              <div class="flex align_center input_row">
                <img class="icon_input" src="../../assets/img/icon_banji.png" alt="" srcset="">
                <el-select class="select_warp" v-model="form.classId" placeholder="请选择班级">
                  <el-option :label="item.name" :value="item.id" v-for="(item, index) in classList"
                    :key="item.id"></el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item prop="deptId">
              <div class="flex align_center input_row">
                <img class="icon_input" src="../../assets/img/icon_bumen.png" alt="" srcset="">
                <!-- <el-select class="select_warp" v-model="form.deptId" placeholder="请选择部门">
                  <el-option :label="item.dictLabel" :value="item.dictValue" v-for="(item, index) in deptList"
                    :key="item.dictValue"></el-option>
                </el-select> -->
                <el-cascader placeholder="请选择部门" style="width: 100%;" v-model="form.deptVal" :options="deptList"
                  :props="{ expandTrigger: 'hover' }" @change="changeDepart"></el-cascader>
              </div>
            </el-form-item>
            <el-checkbox-group v-model="form.type">

              <div class="agrem flex justify-content-center">
                <el-checkbox name="type">
                  <span>我已阅读并同意</span>
                </el-checkbox>
                <el-link type="danger" @click="agreeShow(2)">《注册协议》</el-link>和
                <el-link type="danger" @click="agreeShow(3)">《用户须知》</el-link>
              </div>

            </el-checkbox-group>

            <el-button :loading="loading" class="login_btn" style="width:100%;margin-bottom:30px;"
              @click.native.prevent="sumbitFun">立即注册
            </el-button>
            <div class="tips flex justify-content-center">
              <span>已有账号</span>
              <el-link type="danger" @click="loginTo">立即登录</el-link>
            </div>
          </el-form>
        </div>
      </div>
    </div>
    <div class="footer">
      <p>联系我们：0516-886523556</p>
      <p>主办单位：地铁集团 备案号：苏ICP备05002356号-2</p>
    </div>
    <el-dialog :title="agreeData.title" :visible.sync="dialogVisible" :fullscreen="true">
      <div v-html="agreeData.content"></div>
    </el-dialog>
  </div>
</template>

<script>
import { GVerify } from "@/assets/js/verifyCode"
import { isPhoneno } from '@/utils/validate'
import { registerDo, loadShoe, commonClause } from "@/api/user";
export default {
  name: 'Login',
  data() {
    const validPhone = (rule, value, callback) => {
      if (!isPhoneno(value)) {
        callback(new Error('手机号格式有误'))
      } else {
        callback()
      }
    }
    return {
      verifyCode: null,
      dialogVisible: false,
      agreeData: {},
      loading: false,
      form: {
        phone: '',
        code: '',
        password: '',
        classId: '',
        className: '',
        deptId: '',
        deptName: '',
        type: ''
      },
      loginRules: {
        phone: [{ required: true, trigger: 'blur', validator: validPhone }],
        code: [{ required: true, trigger: 'blur', message: '请输入验证码' }],
        password: [{ required: true, trigger: 'blur', message: '密码不可为空' }],
        classId: [{ required: true, trigger: 'blur', message: '请选择班级' }],
        deptId: [{ required: true, trigger: 'blur', message: '请选择部门' }]
      },
      passwordType: 'password',
      confirmPasswordType: 'password',
      classList: [],
      deptList: []
    };
  },
  computed: {},
  mounted() {
    this.verifyCode = new GVerify("v_container");
    this.loadClassBm();
  },
  methods: {
    // 协议
    agreeShow(type) {
      commonClause({
        type: type
      }).then(res => {
        console.log(res);
        if (res.code == 200) {
          this.agreeData = res.data[0];
          console.log(this.agreeData);
          this.dialogVisible = true;
        }
      })
    },
    changeDepart(e) {  //修改部门
      console.log(e);
      let name = '';
      this.deptList.forEach((item) => {
        if (item.value == e[0]) {
          name = item.children.filter(event => {
            return event.id == e.value
          })[0].label
        }
      });
      this.form.deptName = name;
      this.form.deptId = e[1];
    },
    loadClassBm() {
      loadShoe().then(res => {
        this.classList = res.data.classList
        let list = []
        res.data.deptList.forEach(item => {
          let children = [];
          item.child.forEach(e => {
            children.push({
              value: e.id,
              label: e.name
            })
          })
          list.push({
            value: item.id,
            label: item.name,
            children
          })
        })
        this.deptList = list;
      })
    },
    // 注册
    sumbitFun() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.classList.forEach(item => {
            if (item.id == this.form.classId) {
              this.form.className = item.name;
            }
          })
          this.deptList.forEach(item => {
            if (item.id == this.form.deptId) {
              this.form.deptName = item.name;
            }
          })
          if (this.verifyCode.options.code + '' !== this.form.code + '') {
            return this.$message.error("验证码填写有误")
          }
          registerDo(this.form).then(res => {
            if (res.code == 200) {
              this.$router.push(`/login`);
              this.$message.success("注册成功")
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });

    },
    loginTo() {
      this.$router.push('/login');
    }
  },
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/login';
</style>